/**
 * Removes Unicode bidi controls: the FSI..PDI isolates plus the older embedding and
 * override marks.
 *
 * Fluent wraps every interpolated variable in FSI/PDI so a right-to-left value cannot
 * reorder the text around it. They render as nothing, but they are part of the string:
 * they travel into the clipboard, into `textContent`, and into accessible names computed
 * from the markup. Two strings that look identical therefore need not compare equal, and
 * nothing about the output shows why. Strip them wherever a translated string leaves the
 * DOM or is compared as text.
 */
export function stripBidiTokens(text: string): string {
    return text.replace(/[\u200E\u200F\u202A-\u202E\u2066-\u2069]/g, '');
}
